import { Card, CardContent } from '../ui/card';
import { Brain, Wind, RefreshCw, Users } from 'lucide-react';

const frameworks = [
  {
    icon: Brain,
    title: "The Inner Paradox",
    description: "Voice 1 (the critic) meets Voice 2 (the curious). Who's talking when you miss the shot?"
  },
  {
    icon: Wind,
    title: "Fight, Flight, Freeze, Fawn, or Flow",
    description: "Learning to recognize and work with your nervous system responses under pressure, anchoring through sensation and rhythm."
  },
  {
    icon: RefreshCw,
    title: "From Drama to Empowerment",
    description: "Moving from Victim-Rescuer-Persecutor patterns to Creator-Challenger-Coach dynamics."
  },
  {
    icon: Users,
    title: "Doubles as Dojo",
    description: "Relationships in motion. Practicing communication, co-regulation, and conflict resolution."
  }
];

const PickleballFramework = () => {
  return (
    <section className="bg-foreground text-background">
      <div className="container-mobile section-spacing max-w-5xl mx-auto">
        <div className="text-center mb-6">
          <p className="text-primary font-semibold tracking-[0.15em] uppercase text-sm mb-2">
            An Abundant Laboratory
          </p>
          <h2 className="text-background mb-6">
            The ParadoxEdge Framework
          </h2>
        </div>

        <p className="text-background/70 text-center leading-relaxed max-w-3xl mx-auto mb-14 text-lg">
          A movement-based coaching experience where the patterns that show up in your pickleball game 
          reveal how you navigate pressure, partnership, and power in all areas of life.
        </p>

        <div className="grid gap-6 md:grid-cols-2">
          {frameworks.map((item, i) => (
            <Card key={i} className="bg-background/10 border-background/20 hover:border-primary/40 transition-all duration-500 hover:-translate-y-1">
              <CardContent className="p-6">
                <div className="flex items-start gap-5">
                  <div className="w-12 h-12 rounded-2xl bg-primary/20 flex items-center justify-center flex-shrink-0">
                    <item.icon className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="text-background font-medium text-lg mb-2">{item.title}</h3>
                    <p className="text-background/60 leading-relaxed text-base">{item.description}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PickleballFramework;
